import {Component, Input, EventEmitter, Output, HostBinding, HostListener} from '@angular/core';
import {ProgressButtonOptions} from '@service/models/interfaces/progress-button.interface';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'mat-bar-button',
    templateUrl: './bar-button.component.html',
    styleUrls: ['./bar-button.component.scss']
})
export class BarButtonComponent {
    _options: ProgressButtonOptions;
    @Input() ariaLabel: string = '';
    @Input() ariaDescribedBy: string = '';
    @Output() btnClick: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

    @HostBinding('style.pointer-events')
    get hostPointerEvents(): string {
        return this._options?.disabled || this._options?.active ? 'none' : 'auto';
    }

    public get options(): ProgressButtonOptions {
        return this._options;
    }

    @Input() set options(newValue: ProgressButtonOptions) {
        this._options = newValue;
    }

    public get disabled(): boolean {
        return this._options.disabled;
    }

    @Input() set disabled(newValue: boolean) {
        this._options.disabled = newValue;
    }

    @HostListener('click', ['$event'])
    handleClick(event: MouseEvent): void {
        if (!this.options.disabled && !this.options.active) {
            this.btnClick.emit(event);
        } else {
            event.preventDefault();
        }
    }

}
